
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

interface StatusRefreshButtonProps {
  isAdmin: boolean;
  isApprovedMember: boolean;
  checkIsAdmin: () => Promise<boolean>;
  checkIsApprovedMember: () => Promise<boolean>;
}

const StatusRefreshButton = ({ 
  isAdmin, 
  isApprovedMember, 
  checkIsAdmin, 
  checkIsApprovedMember 
}: StatusRefreshButtonProps) => {
  const handleRefreshStatus = () => {
    Promise.all([
      checkIsAdmin(),
      checkIsApprovedMember()
    ]).then(([isAdmin, isApproved]) => {
      if (isAdmin) {
        toast.success('Admin access confirmed! Refresh the page if needed.');
      } else if (isApproved) {
        toast.success('Member status confirmed as approved.');
      } else {
        toast.info('Your membership is still pending approval.');
      }
    });
  };

  return (
    <div className="mt-8 text-center">
      <Button 
        variant="outline" 
        size="sm"
        onClick={handleRefreshStatus}
      >
        Refresh Status
      </Button>
      <p className="text-xs text-gray-500 mt-2">
        Admin status: {isAdmin ? 'Yes' : 'No'} | Approved member: {isApprovedMember ? 'Yes' : 'No'}
      </p>
    </div>
  );
};

export default StatusRefreshButton;
